import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';
import cartRemote from '../../../api/cartRemote';
import paymentRemote from '../../../api/paymentsRemote';
import POSearchFilters from '../../common/POSearchFilters';
import FwdOrdersTable from './FwdOrdersTable';
import ManualEntryModalContainer from '../../gha/manageOrders/manualEntry/ManualEntryModalContainer';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import PickupOrderFwd from '../../../models/PickupOrderFwd';

import moment, { Moment } from 'moment';
import { UserRoleType } from '../../../models/User';
import PaymentsDetail from '../../../models/PaymentDetails';
import OrderNumberSearch from '../../common/OrderNumberSearch';
import SplitGoStepperModal from '../../common/orders/SplitGoStepperModal';
import FwdGoAwbsTable from './FwdGoAwbsTable';
import { Button, Tab, Tabs } from '@material-ui/core';
import PoDModalContainer from '../../poD/PoDModalContainer';

import style from './fwdOrdersTable.module.css';
import commonStyles from '../../common/common.module.css';
import CancelOrderModal from '../../common/CreditWallet';
import ConvertPoModal from './ConvertPoModal';
import PaymentsPO from '../../../models/PaymentsPO';

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

interface FwdOrdersListContainerState {
  viewMode: 'orders' | 'awbs';
  bulkStepperOpen: boolean;
  selectedBulkAwbs: any[];
  poList: Array<PickupOrderFwd>;
  startDate: Moment;
  endDate: Moment;
  startTime: string;
  endTime: string;
  keyword: string;
  currDate: boolean;
  errorKeyword: boolean;
  completed: boolean;
  progressBar: boolean;
  cancelOrderModal: boolean;
  payments: PaymentsDetail;
  selectedOrder: string;
  suspended: boolean;
  openModalManualEntry: boolean;
  convertPoModalOpen: boolean;
  convertPoPayments: PaymentsPO | undefined;
  convertPoNumber: string;
  tabValue: number;
  isModalPoDOpen: boolean;
  podAwbCode: string;
  podAwbNumber: string;
  podAwbVersion: number;
};

interface FwdOrdersListContainerProps {
  receiveError: Function;
  history: any;
  type: string;
};

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-prevent-tabpanel-${index}`}
      aria-labelledby={`scrollable-prevent-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

class FwdOrdersListContainer extends Component <FwdOrdersListContainerProps, FwdOrdersListContainerState> {

  state: FwdOrdersListContainerState = {
    viewMode: 'orders',
    bulkStepperOpen: false,
    selectedBulkAwbs: [],
    poList: [],
    startDate: moment(),
    endDate: moment(),
    startTime: '',
    endTime: '',
    keyword: '',
    currDate: false,
    errorKeyword: false,
    completed: true,
    progressBar: false,
    cancelOrderModal: false,
    payments: {} as PaymentsDetail,
    selectedOrder: '',
    suspended: false,
    openModalManualEntry: false,
    convertPoModalOpen: false,
    convertPoPayments: undefined,
    convertPoNumber: '',
    tabValue: 0,
    isModalPoDOpen: false,
    podAwbCode: '',
    podAwbNumber: '',
    podAwbVersion: 0
  };

  componentDidMount() {

    const currState: FwdOrdersListContainerState = { ...this.state };
    const startDate: string = currState.startDate.format('YYYYMMDD');
    const endDate: string = currState.endDate.format('YYYYMMDD');

    this.doGetOrdersRequest(startDate, endDate, currState.startTime, currState.endTime, currState.keyword, true);
  };

  componentDidUpdate(prevProps: FwdOrdersListContainerProps) {
    const currentDate: string = moment().format('YYYYMMDD');

    if (prevProps.type !== this.props.type) {
      this.setState({
        poList: [],
        startDate: moment(),
        endDate: moment(),
        startTime: '',
        endTime: '',
        keyword: '',
        currDate: false,
        errorKeyword: false
      });
      
      this.doGetOrdersRequest(currentDate, currentDate, '', '', '', true);
    }
  }

  changeTabValue = (event: React.ChangeEvent<{}>, newValue: number): void => {
    let tabValue = 0;
    tabValue = newValue;
    this.setState({ tabValue });
  };

  handleChangeDate = (type: string, date: Moment): void => {

    switch (type) {
      case 'startDate': this.setState({ startDate: date });
        break;
      case 'endDate': this.setState({ endDate: date });
        break;
      default: break;
    };
  };

  showCompletedOrder = (type: string): void => {
    const poList = [...this.state.poList];
    const currState: FwdOrdersListContainerState = { ...this.state };
    const startDate: string = currState.startDate.format('YYYYMMDD');
    const endDate: string = currState.endDate.format('YYYYMMDD');
    let filteredList;
    if (type === 'completed') {
      filteredList = poList.filter((po: PickupOrderFwd) => {
        if (po.order_type === 'go') {
          return true; // Orders remain here after delivery to Customs
        }
        if (po.truck_status.fully_delivered) {
          return po.truck_status.fully_delivered === !this.state.completed;
        } else {
          return po;
        }
      });
      this.setState({ poList: filteredList, completed: !this.state.completed });
    } else if (type === 'suspended') {
      filteredList = poList.filter((po: PickupOrderFwd) => {
        if (po.suspended) {
          return po.suspended === !this.state.suspended;
        } else {
          return po;
        }
      });
      this.setState({ poList: filteredList, suspended: !this.state.suspended }, () => {
        this.doGetOrdersRequest(startDate, endDate, '', '', '', true);
      
      });
    }
    // this.doGetOrdersRequest(startDate, endDate, '', '', '', true);
  }

  handleChangeKeyword = (event: any): void => {

    const value: string = event.target.value;
    const keyword: string = value.toUpperCase();

    this.setState({ keyword });
  };

  handleChangeTime = (type: string, event: any): void => {

    const time: string = event.target.value;

    switch (type) {
      case 'startTime': this.setState({ startTime: time });
        break;
      case 'endTime': this.setState({ endTime: time }); 
        break;
      default: break;
    };
  };

  handleClick = (): void => {
    this.setState({ keyword: '', currDate: false });
  };

  search = (): void => {

    let startDate: string = this.state.startDate.format('YYYYMMDD');
    let endDate: string = this.state.endDate.format('YYYYMMDD');
    let startTime: string = this.state.startTime;
    let endTime: string = this.state.endTime;

    if (this.state.keyword !== '' && this.state.keyword.length >= 3 ) {
      startDate = '';
      endDate = '';
      startTime = '';
      endTime = '';
    };

    if (this.state.keyword !== '' && this.state.keyword.length < 3 ) {
      return this.setState({ errorKeyword: true }); 
    }
    this.setState({ progressBar: true }, () => {
      this.doGetOrdersRequest(startDate, endDate, startTime, endTime, this.state.keyword, true);
    });
  };

  doGetOrdersRequest = (startDate: string, endDate: string, startTime: string, endTime: string, keyword: string, doSort: boolean): void => {

    pickupOrderRemote.getPickupOrdersFwd(this.props.type, startDate, endDate, startTime, endTime, keyword, doSort, this.state.completed, this.state.suspended).then((resp: ApiResponse<Array<PickupOrderFwd>>) => {
    
      const poList: Array<PickupOrderFwd> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (poList) {
        this.setState({ poList, progressBar: false });
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  linkPoDetails = (poNumber: string): void => {
    if (this.props.type === 'po') {
      this.props.history.push(`/po/${poNumber}`);
    }

    if (this.props.type === 'do') {
      this.props.history.push(`/do/${poNumber}`);
    }

    if (this.props.type === 'go') {
      this.props.history.push(`/go/${poNumber}`);
    }
  };

  handleConvertToPo = (poNumber: string): void => {
    this.setState({ convertPoModalOpen: true, convertPoNumber: poNumber, convertPoPayments: undefined });
    pickupOrderRemote.getPickupOrder(poNumber).then(poResp => {
        if(poResp.result) {
            const awbs = poResp.result.list.map(a => ({ code: a.code, number: a.number, version: a.version}));
            paymentRemote.getPoPayments(awbs, 'pending').then(payResp => {
                if (payResp.result) {
                   this.setState({ convertPoPayments: payResp.result });
                }
            });
        }
    });
  }

  handleOpenPodModal = (orderNumber: string): void => {
    pickupOrderRemote.getPickupOrder(orderNumber).then((resp: ApiResponse<any>) => {
      const order = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
        return;
      }

      if (!order || !order.list || order.list.length === 0) {
        this.props.receiveError({ errorCode: 'awb-not-found', longDescription: 'No AWB found for this order to open PoD.' });
        return;
      }

      const awb = order.list[0];
      this.setState({
        isModalPoDOpen: true,
        podAwbCode: awb.code,
        podAwbNumber: awb.number,
        podAwbVersion: awb.version
      });
    });
  }

  handleClosePodModal = (_modalType?: string): void => {
    this.setState({ isModalPoDOpen: false });
  }

  disabledDate = (): void => {
    this.setState({ currDate: true });
  };

  openModal = (order: PickupOrderFwd): void => {
    // this.setState({ id });
    paymentRemote.getPaymentDetailsByOrder(order.number).then((resp: ApiResponse<PaymentsDetail>) => {
 
      const paymentDetail: PaymentsDetail | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (paymentDetail) {

        const paidStatus: string = paymentDetail.status;
        const disabled: boolean = paidStatus !== 'pending';
        this.setState({ payments: paymentDetail }, () => {
          this.setState({ cancelOrderModal: true, selectedOrder: order.number});
        })
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  cancelOrder = (): void => {
    pickupOrderRemote.cancelOrder(this.state.selectedOrder).then((resp: ApiResponse<boolean>) => {
      const result: boolean | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.setState({ cancelOrderModal: false, selectedOrder: '' }, () => {
          this.search();
        });
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  closeModal = (): void => {
    this.setState({ cancelOrderModal: false });

  }

  handleOpenModalManualEntry = (): void => {
    this.setState({ openModalManualEntry: true });
  }

  handleCloseModalManualEntry = (): void => {
    this.setState({ openModalManualEntry: false });
  }

  changeFocuses =(): void => {

    this.setState({ errorKeyword: false });

    if (this.state.keyword === '') {
      this.setState({ currDate: false });
    }
  }

  render() {

    return ( 

      <Fragment>
        <div className={`${ commonStyles.wrapper } ${ commonStyles.pb0 }`}>
          <h1 className={ commonStyles.header }>Filter</h1>
          <OrderNumberSearch
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            startTime={this.state.startTime}
            endTime={this.state.endTime}
            keyword={this.state.keyword}
            handleChangeDate={this.handleChangeDate}
            handleChangeTime={this.handleChangeTime}
            handleChangeKeyword={this.handleChangeKeyword}
            search={this.search}
            handleClick={this.handleClick}
            disabledDate={this.disabledDate}
            currDate={this.state.currDate}
            changeFocuses={this.changeFocuses}
            userRole={UserRoleType.FORWARDER}
            errorKeyword={ this.state.errorKeyword }
            completeOrders={ this.showCompletedOrder }
            completed={ this.state.completed }
            progressBar={ this.state.progressBar }
            suspended={ this.state.suspended }
            orderType={ this.props.type }
          />
        </div>
        {this.props.type === 'go' && (
          <>
            <Tabs
              value={ this.state.tabValue }
              onChange={ this.changeTabValue }
              scrollButtons="off"
              aria-label="go order tabs"
              className={ `${commonStyles.tabContainer} ${commonStyles.mb4} ${style.tabWrapper}` }
              classes={{ indicator: style.tabIndicator }}
              variant="fullWidth"
              indicatorColor='secondary'
            >
              <Tab
                className={ `${commonStyles.tab} ${this.state.tabValue === 0 ? style.selectedTab : ''}` }
                classes={{ 
                  root: style.tab,
                  selected: style.selectedTab 
                }}
                label="Orders"
              />
              <Tab
                className={ `${commonStyles.tab} ${this.state.tabValue === 1 ? style.selectedTab : ''}` }
                classes={{ 
                  root: style.tab,
                  selected: style.selectedTab }}
                label="Global AWBs"
              />
            </Tabs>

            <TabPanel value={this.state.tabValue} index={0}>
              <FwdOrdersTable 
                pickupOrders={ this.state.poList }
                linkPoDetails={ this.linkPoDetails }
                handleOpenPodModal={ this.handleOpenPodModal }
                type={this.props.type}
                openModal={ this.openModal }
                history={this.props.history}
                handleOpenModalManualEntry={this.handleOpenModalManualEntry}
                handleConvertToPo={this.handleConvertToPo}
              />
            </TabPanel>

            <TabPanel value={this.state.tabValue} index={1}>
              <FwdGoAwbsTable 
                pickupOrders={ this.state.poList }
                onSelectionChange={(selected: any) => this.setState({ selectedBulkAwbs: selected })}
              />
            </TabPanel>
          </>
        )}

        {this.state.tabValue === 1 && (
          <div className={ style.footerActions }>
            <Button variant="contained" color="primary" disabled={this.state.selectedBulkAwbs.length === 0} onClick={() => this.setState({ bulkStepperOpen: true })}>
              Convert to PO ({this.state.selectedBulkAwbs.length})
            </Button>
          </div>
        )}

        {this.state.bulkStepperOpen && this.state.selectedBulkAwbs.length > 0 && (
          <SplitGoStepperModal
            open={this.state.bulkStepperOpen}
            onClose={() => this.setState({ bulkStepperOpen: false, selectedBulkAwbs: [] }, () => this.search())}
            selectedAwbs={this.state.selectedBulkAwbs}
            goOrder={this.state.poList.find(p => p.number === this.state.selectedBulkAwbs[0].go_number) as any}
            history={this.props.history}
            userRole={UserRoleType.GHA}
          />
        )}

        {
          this.state.openModalManualEntry &&
          <ManualEntryModalContainer
            type={this.props.type}
            history={this.props.history}
            modalOpen={this.state.openModalManualEntry}
            handleCloseModal={this.handleCloseModalManualEntry}
            driverData={{
              name: '',
              company: '',
              check_in: null
            }}
          />
        }
        {
          this.state.cancelOrderModal && 
          <CancelOrderModal
            modalOpen={this.state.cancelOrderModal}
            handleClose={ this.closeModal }
            cancelOrder={ this.cancelOrder }
            // suspendOrder={ this.suspendOrder }
            payments={this.state.payments}
          />
        }
        {
          this.state.convertPoModalOpen &&
          <ConvertPoModal
            modalOpen={this.state.convertPoModalOpen}
            handleClose={() => this.setState({ convertPoModalOpen: false }, () => this.search())}
            proceed={(paymentDetails?: any) => {
              const apiCall = paymentDetails 
                ? cartRemote.convertGoToPoPayment(this.state.convertPoNumber, paymentDetails.paymentType, paymentDetails.paymentInfo, paymentDetails.stripePaymentMethodId)
                : cartRemote.convertGoToPo(this.state.convertPoNumber);
                
              apiCall.then((resp: ApiResponse<any>) => {
                const error: ResponseError | undefined = resp.error;
                if (error) {
                  this.props.receiveError(error);
                } else {
                  this.setState({ convertPoModalOpen: false });
                  this.props.history.push(`/po/${this.state.convertPoNumber}`);
                }
              });
            }}
            payments={this.state.convertPoPayments}
            orderNumber={this.state.convertPoNumber}
            history={this.props.history}
          />
        }

        {
          this.state.isModalPoDOpen &&
          <PoDModalContainer
            isModalOpen={ this.state.isModalPoDOpen }
            handleCloseModal={ this.handleClosePodModal }
            code={ this.state.podAwbCode }
            number={ this.state.podAwbNumber }
            version={ this.state.podAwbVersion }
          />
        }
      </Fragment>
    );
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
  };
};

export default connect(null, mapDispatchToProps)(FwdOrdersListContainer);